import { Box, OverflowText, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => (
	<CssColumnGrid columns={2}>
		<Text semiBold text="overflow (tooltip)" />
		<Text semiBold text="not overflow (no tooltip)" />
		<Box
			border={STANDARD_BORDER_STYLE}
			display="inline-flex"
			padding={2}
			width={200}
		>
			<OverflowText text="The quick brown fox jumps over the lazy dog!" />
		</Box>
		<Box
			border={STANDARD_BORDER_STYLE}
			display="inline-block"
			padding={2}
			width={300}
		>
			<OverflowText text="The quick brown fox jumps over the lazy dog!" />
		</Box>
	</CssColumnGrid>
);
